module.exports = __webpack_public_path__ + "static/media/20170806_11day_0495AT.3bdcb2e4.jpg";